export default "__VITE_ASSET__BLJsrrsQ__"